import React from 'react'
import {useState, useContext, useEffect} from 'react'
import {useQuery} from 'react-query'
import {FeedbackContext} from '../../../../Components/Context/FeedbackContext'
import {Loading} from '../../../../Components/Loading/Loading'
import {ErrorConnection} from '../../../../Components/Error/Error'
import {Spinner} from 'react-bootstrap'
import * as Api from '../../../../api/Api'
import {useGetToken} from '../../../../Hooks/CustomHooks'
import * as Utilities from '../../../../Components/Utils/Utils'
import $ from 'jquery'
import {Helmet} from 'react-helmet'
import '../mapplic.css'
import Modal from 'react-bootstrap/Modal'

function All_in({unidadEconomicaId, unidadEconomicaName, mes, anio1, anio2, categoria}) {
  const [mapplicObj, setMapplicObj] = useState(null)
  const token = useGetToken()

  const [smShow, setSmShow] = useState(false)
  const [currentIndicadorAllIn, setCurrentIndicadorAllIn] = useState({
    title: null,
    anio1: {
      ventasValor: null,
      ventasm2: null,
      arriendo_ventas: null,
      allin: null,
      area: null,
      rentaFijam2: null,
      rentaTotalm2: null,
      fondom2: null,
      gastocomunm2: null,
      fechaVencimiento: null,
      tarifaminimaaprobatoria: null,
      tarifagc: null,
    },
    anio2: {
      ventasValor: null,
      ventasm2: null,
      arriendo_ventas: null,
      allin: null,
      area: null,
      rentaFijam2: null,
      rentaTotalm2: null,
      fondom2: null,
      gastocomunm2: null,
      fechaVencimiento: null,
      tarifaminimaaprobatoria: null,
      tarifagc: null,
    },
  })

  const listColor = ['#87c141', '#f4e21a', '#e74157']

  const {feedbackContext, setFeedbackContext} = useContext(FeedbackContext)
  let {data, isLoading, isError, error, isFetching} = useQuery(
    [
      'MapaCalorAllIn',
      {
        unidadEconomica: unidadEconomicaId,
        mes: mes,
        anio1: anio1,
        anio2: anio2,
        categoria: categoria,
      },
    ],
    async () =>
      await Api.MapaCalorAllin({
        unidadEconomicaId: unidadEconomicaId,
        mes: mes,
        anio1: anio1,
        anio2: anio2,
        categoria: categoria,
        token: token,
      }),
    {
      enabled: true,
    }
  )

  useEffect(() => {
    if (data) {
      if (data.data === null) {
        // setFeedbackContext({ ...feedbackContext, showError: true, idError: data.errorId });
      } else {
        setJsonMapFinalwithSettings(data.data.mapaCalor, data.data.listaCategorias)
      }
    }
  }, [data])

  let coordenadasTemp = []
  document.addEventListener(
    'keyup',
    (e) => {
      if (e.altKey && e.shiftKey && String.fromCharCode(e.keyCode) == 'C') {
        console.log(coordenadasTemp)
      }
    },
    false
  )

  function setJsonMapFinalwithSettings(jsonResponseFromServer, rangos) {
    const settings = {
      mapwidth: '1300',
      mapheight: '1000',
      defaultstyle: 'normal',
      styles: [],
      groups: [],
    }

    rangos.forEach(function (currentValue, index, array) {
      settings.styles.push({
        class: 'statusClass' + currentValue.value,
        base: {
          fill: listColor[index],
          'fill-opacity': '0.4',
        },
        hover: {
          'fill-opacity': '0.8',
        },
        active: {
          fill: 'green',
          'fill-opacity': '1',
        },
      })
      settings.groups.push({
        id: 'statusCategory' + currentValue.value,
        title: currentValue.label,
        color: listColor[index],
        legend: 'true',
        style: 'statusClass' + currentValue.value,
      })
    })

    let data = jsonResponseFromServer

    data.levels.forEach(function (level, index1, array) {
      if (parseInt(level.id) < 0) level['title'] = 'Sótano ' + Math.abs(parseInt(level.id))
      level['map'] =
        '/../mapas/' +
        unidadEconomicaName.toLowerCase().replace(/\s/g, '') +
        '/piso_' +
        level.id +
        '.svg'
      level.locations.forEach(function (elementLocation, index2, array) {
        elementLocation['pin'] = 'hidden'
        elementLocation['titleModal'] = elementLocation['title']
        elementLocation['title'] =
          elementLocation['title'].length > 10
            ? elementLocation['title'].slice(0, 15) + '...'
            : elementLocation['title']
        elementLocation['category'] = 'statusCategory' + elementLocation.categoria
        elementLocation['style'] = 'statusCategory' + elementLocation.categoria
      })
    })

    let returnedTarget = Object.assign(data, settings)

    let mapplicObjTemp = {
      source: returnedTarget,
      height: 'auto',
      sidebar: false,
      hovertip: true,
      maxscale: 10,
      developer: false,
      highlight: true,
      zoom: true,
      mousewheel: true,
      closezoomout: true,
      thumbholder: true,
    }

    //#region Funcion Colorea Bloque
    setTimeout(function () {
      $('.mapplic-pin').each(function (index) {
        $(this).css('background-color', 'white')
      })
    }, 1000)

    let encontrados = 0
    let locationNull = false
    function setColorLocatarios() {
      for (let indexLevel = 0; indexLevel < data.levels.length; indexLevel++) {
        if (locationNull && encontrados < 3) break
        const element = data.levels[indexLevel]

        for (let indexLocation = 0; indexLocation < element.locations.length; indexLocation++) {
          if (locationNull && encontrados < 3) break
          const elementLocation = element.locations[indexLocation]

          locationNull = $('#' + elementLocation.id).length == 0
          if (!locationNull) encontrados++
          else console.log(elementLocation.id, $('#' + elementLocation.id).length)

          let groupTemp = settings.groups.find(
            (group) => group.id == 'statusCategory' + elementLocation.categoria
          )
          let colorTemp = groupTemp != null ? groupTemp.color : '#b9b9b9'
          let styleTemp = `fill: ${colorTemp} !important;`
          if (groupTemp == null)
            console.log(elementLocation.id, elementLocation.categoria, 'Sin Categoría')

          $('#' + elementLocation.id).attr('style', styleTemp)
          $('#' + elementLocation.id).attr('class', 'colorDefault')
          $('#' + elementLocation.id).attr('data-toggle', 'tooltip')
          $('#' + elementLocation.id).attr('data-placement', 'Tooltip on top')
          $('#' + elementLocation.id).attr('data-bs-html', 'true')

          $('#' + elementLocation.id).attr(
            'title',
            elementLocation.id + ' : ' + elementLocation.titleModal
          )

          $('#' + elementLocation.id).on('click touchstart', function () {
            setSmShow(true)
            setCurrentIndicadorAllIn({
              ...elementLocation.indicadores,
              title: elementLocation.id + ' : ' + elementLocation.titleModal,
            })

            // let x = $(".mapplic-coordinates-x").html();
            // let y = $(".mapplic-coordinates-y").html();
            // let elementTemp = { id: elementLocation.id, x: x, y: y };

            // let found = coordenadasTemp.find(function (element) {
            //     return element.id == elementLocation.id;
            // });

            // // console.log(elementTemp);
            // if (found == null) coordenadasTemp.push(elementTemp);
            // $("#" + (elementLocation.id)).attr("class", "colorClick");
          })
        }
      }
      if (locationNull)
        setTimeout(function () {
          locationNull = false
          setColorLocatarios()
        }, 1500)
    }

    setTimeout(function () {
      setColorLocatarios()
    }, 1500)

    //#endregion

    setMapplicObj(mapplicObjTemp)
  }

  if (isLoading) return <Loading />
  if (isError) return <ErrorConnection error={error} />
  return (
    <>
      {isFetching ? (
        <Spinner animation='grow' variant='secondary' />
      ) : data?.data && data?.data?.mapaCalor?.levels.length > 0 ? (
        <>
          <div className='application'>
            <Helmet>
              <script>
                {`
                    if (` +
                  JSON.stringify(mapplicObj) +
                  ` != null) {
                        $('#mapplic_container_all_in').mapplic(` +
                  JSON.stringify(mapplicObj) +
                  `);

                        $(document).ready(function () {
                            setTimeout(function () {
                                $('[data-toggle="tooltip"]').tooltip({ container: 'body' })
                            }, 1800)
                        });

                    }
                    `}
              </script>
            </Helmet>
          </div>

          <Modal
            size='lg'
            show={smShow}
            aria-labelledby='contained-modal-title-vcenter'
            centered
            onHide={() => setSmShow(false)}
          >
            <Modal.Header className='header-personalizable' closeButton>
              <Modal.Title id='contained-modal-title-vcenter'>
                {currentIndicadorAllIn.title}
              </Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <div className='row'>
                <div className='col-xl-6'>
                  <div className='text-center'>
                    <h1 className='fw-bold text-gray-800 text-center lh-lg'>
                      {Utilities.monthFullNames[mes - 1]} {anio1}
                    </h1>
                  </div>
                  <div className='d-flex align-items-center bg-danger-mall rounded p-5 mb-2'>
                    <div className='flex-grow-1 me-2'>
                      <div className='text-gray-800 fs-6 fw-bolder'>Venta Soles</div>
                    </div>
                    <span className='fw-bolder text-red-mall py-1 '>
                      {Utilities.comillasFix(currentIndicadorAllIn.anio1?.ventasValor, true)}
                    </span>
                  </div>
                  <div className='d-flex align-items-center bg-danger-mall rounded p-5 mb-2'>
                    <div className='flex-grow-1 me-2'>
                      <div className='text-gray-800 fs-6 fw-bolder'>
                        Venta por m<sup>2</sup>
                      </div>
                    </div>
                    <span className='fw-bolder text-red-mall py-1 '>
                      {Utilities.comillasFix(currentIndicadorAllIn.anio1?.ventasm2, true)}
                    </span>
                  </div>
                  <div className='d-flex align-items-center bg-danger-mall rounded p-5 mb-2'>
                    <div className='flex-grow-1 me-2'>
                      <div className='text-gray-800 fs-6 fw-bolder'>% Arriendo Ventas</div>
                    </div>
                    <span className='fw-bolder text-red-mall py-1 '>
                      {' '}
                      {Utilities.comillasFix(currentIndicadorAllIn.anio1?.arriendo_ventas, true)}%
                    </span>
                  </div>

                  <div className='d-flex align-items-center bg-danger-mall rounded p-5 mb-2'>
                    <div className='flex-grow-1 me-2'>
                      <div className='text-gray-800 fs-6 fw-bolder'>All In</div>
                    </div>
                    <span className='fw-bolder text-red-mall py-1 '>
                      {Number(currentIndicadorAllIn.anio1?.ventasValor || 0) === 0
                        ? ''
                        : ` ${Utilities.comillasFix(currentIndicadorAllIn.anio1?.allin, true)}%`}
                    </span>
                  </div>
                  <div className='d-flex align-items-center bg-danger-mall rounded p-5 mb-2'>
                    <div className='flex-grow-1 me-2'>
                      <div className='text-gray-800 fs-6 fw-bolder'>Área</div>
                    </div>
                    <span className='fw-bolder text-red-mall py-1 '>
                      {' '}
                      {Utilities.comillasFix(currentIndicadorAllIn.anio1?.area, true)}
                    </span>
                  </div>
                  <div className='d-flex align-items-center bg-danger-mall rounded p-5 mb-2'>
                    <div className='flex-grow-1 me-2'>
                      <div className='text-gray-800 fs-6 fw-bolder'>
                        Renta fija por m<sup>2</sup>
                      </div>
                    </div>
                    <span className='fw-bolder text-red-mall py-1 '>
                      {' '}
                      {Utilities.comillasFix(currentIndicadorAllIn.anio1?.rentaFijam2, true)}
                    </span>
                  </div>
                  <div className='d-flex align-items-center bg-danger-mall rounded p-5 mb-2'>
                    <div className='flex-grow-1 me-2'>
                      <div className='text-gray-800 fs-6 fw-bolder'>
                        Renta total por m<sup>2</sup>
                      </div>
                    </div>
                    <span className='fw-bolder text-red-mall py-1 '>
                      {' '}
                      {Utilities.comillasFix(currentIndicadorAllIn.anio1?.rentaTotalm2, true)}
                    </span>
                  </div>
                  <div className='d-flex align-items-center bg-danger-mall rounded p-5 mb-2'>
                    <div className='flex-grow-1 me-2'>
                      <div className='text-gray-800 fs-6 fw-bolder'>
                        Fondo por m<sup>2</sup>
                      </div>
                    </div>
                    <span className='fw-bolder text-red-mall py-1 '>
                      {' '}
                      {Utilities.comillasFix(currentIndicadorAllIn.anio1?.fondom2, true)}
                    </span>
                  </div>
                  <div className='d-flex align-items-center bg-danger-mall rounded p-5 mb-2'>
                    <div className='flex-grow-1 me-2'>
                      <div className='text-gray-800 fs-6 fw-bolder'>
                        Gasto Común por m<sup>2</sup>
                      </div>
                    </div>
                    <span className='fw-bolder text-red-mall py-1 '>
                      {' '}
                      {Utilities.comillasFix(currentIndicadorAllIn.anio1?.gastocomunm2, true)}
                    </span>
                  </div>
                  <div className='d-flex align-items-center bg-danger-mall rounded p-5 mb-2'>
                    <div className='flex-grow-1 me-2'>
                      <div className='text-gray-800 fs-6 fw-bolder'>Vencimiento del Contrato</div>
                    </div>
                    <span className='fw-bolder text-red-mall py-1 '>
                      {' '}
                      {currentIndicadorAllIn.anio1?.fechaVencimiento}
                    </span>
                  </div>
                  <div className='d-flex align-items-center bg-danger-mall rounded p-5 mb-2'>
                    <div className='flex-grow-1 me-2'>
                      <div className='text-gray-800 fs-6 fw-bolder'>Tarifa mínima aprobatoria</div>
                    </div>
                    <span className='fw-bolder text-red-mall py-1 '>
                      {' '}
                      {Utilities.comillasFix(currentIndicadorAllIn.anio1?.tarifaminimaaprobatoria, true)}
                    </span>
                  </div>
                  <div className='d-flex align-items-center bg-danger-mall rounded p-5 mb-2'>
                    <div className='flex-grow-1 me-2'>
                      <div className='text-gray-800 fs-6 fw-bolder'>Tarifa gasto común</div>
                    </div>
                    <span className='fw-bolder text-red-mall py-1 '>
                      {' '}
                      {Utilities.comillasFix(currentIndicadorAllIn.anio1?.tarifagc, true)}
                    </span>
                  </div>
                </div>

                <div className='col-xl-6'>
                  <div className='text-center'>
                    <h1 className='fw-bold text-gray-800 text-center lh-lg'>
                      {Utilities.monthFullNames[mes - 1]} {anio2}
                    </h1>
                  </div>

                  <div className='d-flex align-items-center bg-light-blue rounded p-5 mb-2'>
                    <div className='flex-grow-1 me-2'>
                      <div className='text-gray-800 fs-6 fw-bolder'>Venta Soles</div>
                    </div>
                    <span className='fw-bolder text-blue py-1 '>
                      {Utilities.comillasFix(currentIndicadorAllIn.anio2?.ventasValor, true)}
                    </span>
                  </div>
                  <div className='d-flex align-items-center bg-light-blue rounded p-5 mb-2'>
                    <div className='flex-grow-1 me-2'>
                      <div className='text-gray-800 fs-6 fw-bolder'>
                        Venta por m<sup>2</sup>
                      </div>
                    </div>
                    <span className='fw-bolder text-blue py-1 '>
                      {Utilities.comillasFix(currentIndicadorAllIn.anio2?.ventasm2, true)}
                    </span>
                  </div>
                  <div className='d-flex align-items-center bg-light-blue rounded p-5 mb-2'>
                    <div className='flex-grow-1 me-2'>
                      <div className='text-gray-800 fs-6 fw-bolder'>% Arriendo Ventas</div>
                    </div>
                    <span className='fw-bolder text-blue py-1 '>
                      {' '}
                      {Utilities.comillasFix(currentIndicadorAllIn.anio2?.arriendo_ventas, true)}%
                    </span>
                  </div>

                  <div className='d-flex align-items-center bg-light-blue rounded p-5 mb-2'>
                    <div className='flex-grow-1 me-2'>
                      <div className='text-gray-800 fs-6 fw-bolder'>All In</div>
                    </div>
                    <span className='fw-bolder text-blue py-1 '>
                      {Number(currentIndicadorAllIn.anio2?.ventasValor || 0) === 0
                        ? ''
                        : ` ${Utilities.comillasFix(currentIndicadorAllIn.anio2?.allin, true)}%`}
                    </span>
                  </div>
                  <div className='d-flex align-items-center bg-light-blue rounded p-5 mb-2'>
                    <div className='flex-grow-1 me-2'>
                      <div className='text-gray-800 fs-6 fw-bolder'>Área</div>
                    </div>
                    <span className='fw-bolder text-blue py-1 '>
                      {' '}
                      {Utilities.comillasFix(currentIndicadorAllIn.anio2?.area, true)}
                    </span>
                  </div>
                  <div className='d-flex align-items-center bg-light-blue rounded p-5 mb-2'>
                    <div className='flex-grow-1 me-2'>
                      <div className='text-gray-800 fs-6 fw-bolder'>
                        Renta fija por m<sup>2</sup>
                      </div>
                    </div>
                    <span className='fw-bolder text-blue py-1 '>
                      {' '}
                      {Utilities.comillasFix(currentIndicadorAllIn.anio2?.rentaFijam2, true)}
                    </span>
                  </div>
                  <div className='d-flex align-items-center bg-light-blue rounded p-5 mb-2'>
                    <div className='flex-grow-1 me-2'>
                      <div className='text-gray-800 fs-6 fw-bolder'>
                        Renta total por m<sup>2</sup>
                      </div>
                    </div>
                    <span className='fw-bolder text-blue py-1 '>
                      {' '}
                      {Utilities.comillasFix(currentIndicadorAllIn.anio2?.rentaTotalm2, true)}
                    </span>
                  </div>
                  <div className='d-flex align-items-center bg-light-blue rounded p-5 mb-2'>
                    <div className='flex-grow-1 me-2'>
                      <div className='text-gray-800 fs-6 fw-bolder'>
                        Fondo por m<sup>2</sup>
                      </div>
                    </div>
                    <span className='fw-bolder text-blue py-1 '>
                      {' '}
                      {Utilities.comillasFix(currentIndicadorAllIn.anio2?.fondom2, true)}
                    </span>
                  </div>
                  <div className='d-flex align-items-center bg-light-blue rounded p-5 mb-2'>
                    <div className='flex-grow-1 me-2'>
                      <div className='text-gray-800 fs-6 fw-bolder'>
                        Gasto Común por m<sup>2</sup>
                      </div>
                    </div>
                    <span className='fw-bolder text-blue py-1 '>
                      {' '}
                      {Utilities.comillasFix(currentIndicadorAllIn.anio2?.gastocomunm2, true)}
                    </span>
                  </div>
                  <div className='d-flex align-items-center bg-light-blue rounded p-5 mb-2'>
                    <div className='flex-grow-1 me-2'>
                      <div className='text-gray-800 fs-6 fw-bolder'>Vencimiento del Contrato</div>
                    </div>
                    <span className='fw-bolder text-blue py-1 '>
                      {' '}
                      {currentIndicadorAllIn.anio2?.fechaVencimiento}
                    </span>
                  </div>
                  <div className='d-flex align-items-center bg-light-blue rounded p-5 mb-2'>
                    <div className='flex-grow-1 me-2'>
                      <div className='text-gray-800 fs-6 fw-bolder'>Tarifa mínima aprobatoria</div>
                    </div>
                    <span className='fw-bolder text-blue py-1 '>
                      {' '}
                      {Utilities.comillasFix(currentIndicadorAllIn.anio2?.tarifaminimaaprobatoria, true)}
                    </span>
                  </div>
                  <div className='d-flex align-items-center bg-light-blue rounded p-5 mb-2'>
                    <div className='flex-grow-1 me-2'>
                      <div className='text-gray-800 fs-6 fw-bolder'>Tarifa gasto común</div>
                    </div>
                    <span className='fw-bolder text-blue py-1 '>
                      {' '}
                      {Utilities.comillasFix(currentIndicadorAllIn.anio2?.tarifagc, true)}
                    </span>
                  </div>
                </div>
              </div>
            </Modal.Body>
          </Modal>

          <div id='mapplic_container_all_in'></div>
        </>
      ) : (
        <div class='alert alert-warning' role='alert'>
          Actualmente no existen datos de ventas para este Mall.
        </div>
      )}
    </>
  )
}

export default All_in
